import React from 'react';

import { FsProps } from './FsProps';
import { FieldSelectYesNo } from './fs-yesno';

export const FieldSelectIsActive = ({
  label = 'Ενεργό',
  name = 'isActive',
  disable = false,
  ...rest
}: FsProps & { readonly disable?: boolean }) => {
  return (
    <FieldSelectYesNo label={label} name={name} disable={disable} {...rest} />
  );
};

